import React from 'react'
import Menu from '../component/Menu';
import HeaderCasestudy from '../component/HeaderCasestudy';
import Casestudybody from '../component/Casestudybody39';
import Footer from '../component/Footer'
import { Helmet } from 'react-helmet';

const CaseStudy39 = ({setBlank}) => {
     
    const headings = "<h2 style='display:inline-block;color:#ffffff;'>Financial Model & Deal Analysis </h2><h4>for a Regional Investment Leader in Real Estate</h4>";

  return (
    <>
        <Helmet>
        <title>Financial Model & Deal Analysis for a Regional Investment Leader in Real Estate </title>
        <meta property="og:title" content="Financial Model & Deal Analysis for a Regional Investment Leader in Real Estate " />
        <meta property='og:description' content='Financial Model & Deal Analysis for a Regional Investment Leader in Real Estate '/>
        <meta name='keywords' content=''/>
        </Helmet>

        <Menu setBlank={setBlank}  />
        <HeaderCasestudy class="header-casestudy39" headings={headings} />  
        <Casestudybody />
        <Footer setBlank={setBlank} />
    </>
  )
}

export default CaseStudy39
